import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import $session from "servicestack/session";
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import TerritoryPicker from 'emun.salesrep/territory-manager/territory/picker/territory-picker'
import ZipcodePicker from 'emun.salesrep/territory-manager/zipcode/picker/zipcode-picker'

// import moment from "moment";

export default class RegionPromptController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		const {
			request = options.region,
			title
		} = options;
		console.info("options", options);
		$ctrl.request = {
			id: request.id,
			name: request.name
		};


		$ctrl.action = request.id ? "Update" : "Create";
		$ctrl.bus = new ServiceBus();
		$ctrl.title = title || `${$ctrl.action} Region...`;
		$ctrl.zipcodes = new AutoQuery({
			url: "QueryZipcodes.json?RegionId=" + $ctrl.request.id,
			autoLoad: true
		});
		$ctrl.territories = new AutoQuery({
			url: "QueryTerritories.json?RegionId=" + $ctrl.request.id,
			autoLoad: true
		});
	}

	$onInit() {
		const $ctrl = this;
	}

	submit() {
		const $ctrl = this;
		$ctrl.bus
			.send(`${$ctrl.action}Region.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.$emit("regionSaved", $ctrl);
				$ctrl.$emit("refresh-regions", response);
				$ctrl.$close(response.data);
			});
	}

	addTerritory() {
		let $ctrl = this;
		$ctrl.territoryIds = [];

		return TerritoryPicker({
			title: "Select Territories...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.bus.send("AddRegionTerritories", {
				RegionId: $ctrl.request.id,
				TerritoryIds: result
			}).then(function (response) {
				$ctrl.territories.load();
			});
		});
	}
	addZipcode() {
		let $ctrl = this;
		$ctrl.zipcodeIds = [];

		return ZipcodePicker({
			title: "Select Zipcodes...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.bus.send("AddRegionZipcodes", {
				RegionId: $ctrl.request.id,
				ZipcodeIds: result
			}).then(function (response) {
				$ctrl.zipcodes.load();
			});
		});
	}
	delete() {
		const $ctrl = this;
		$ctrl.$close($ctrl.request);
	}

	deleteTerritory(territory) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + territory.name, "Remove Territory?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteRegionTerritory.json", {
						RegionId: $ctrl.request.id,
						TerritoryId: territory.id
					})
					.then(function () {
						return $ctrl.territories.load(true);
					})
					.catch(

					);
			});
	}
	deleteZipcode(zipcode) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + zipcode.id, "Remove Zipcode?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteRegionZipcode.json", {
						RegionId: $ctrl.request.id,
						ZipcodeId: zipcode.id
					})
					.then(function () {
						return $ctrl.zipcodes.load(true);
					})
					.catch(

					);
			});
	}

	dismiss() {
		const $ctrl = this;
		//$ctrl.$emit('listSaved', $ctrl);
		$ctrl.$dismiss();
	}
}
